export const STATUS_TYPES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REVIEW_CANCEL: 'REVIEW_CANCEL',
  RETURNED: 'RETURNED',
  PENDING_APPROVAL: 'PENDING_APPROVAL'
};

export const RESPONSE_CODE = {
  DELETE_SUCCESS: 204,
  BAD_REQUEST: 400,
  POST_SUCCESS: 200
};
